import type { StateCreator } from "zustand/vanilla";

import type {
  GlobalBridgeState,
  GlobalRouteState,
  SystemStatus,
} from "../initial-state";
import type { GlobalStore } from "../store";

const isShallowEqual = <T extends object>(current: T, next: T): boolean =>
  (Object.keys(next) as Array<keyof T>).every(
    (key) => next[key] === current[key],
  );

export interface GlobalGeneralAction {
  setRouteState: (route: GlobalRouteState) => void;
  updateBridgeState: (bridge: Partial<GlobalBridgeState>) => void;
  updateSystemStatus: (status: Partial<SystemStatus>) => void;
}

export const generalActionSlice: StateCreator<
  GlobalStore,
  [["zustand/subscribeWithSelector", never]],
  [],
  GlobalGeneralAction
> = (set, get) => ({
  setRouteState: (route) => {
    if (isShallowEqual(get().route, route)) {
      return;
    }

    set({ route });
  },
  updateBridgeState: (bridge) => {
    const nextBridge = {
      ...get().bridge,
      ...bridge,
    };

    if (isShallowEqual(get().bridge, nextBridge)) {
      return;
    }

    set({ bridge: nextBridge });
  },
  updateSystemStatus: (status) => {
    const nextStatus = {
      ...get().status,
      ...status,
    };

    if (isShallowEqual(get().status, nextStatus)) {
      return;
    }

    set({ status: nextStatus });
  },
});
